import React, { useEffect } from 'react';
import { useLanguage } from '../context/language';
import Footer from '../components/Footer';
import Logo from "../assets/logo.png";
import { useHistory, useLocation } from 'react-router-dom'
import Navbar from '../components/Navbar';

const Error404 = () => {
    const { translate } = useLanguage();
    const location = useLocation();

    useEffect(() => {
        translate();
    }, [translate]);

    return (
        <div>
            <Navbar />
            <div className="container">
                <div className="container-main boxes center">
                    <div className="content-pix">
                        <div className="content col-content">
                            <div className="msg-pix">
                                <h4 data-lang-str="msn_error404"> </h4>
                                <h4 data-lang-str="msn_error404_info" style={{ marginTop: 30 }}> </h4>
                            </div>
                        </div>
                    </div>
                    {location.state ?
                        <>
                            <h5 data-lang-str="msn_error404_param" style={{ marginTop: 20 }}> </h5>
                            <h6>order: {location.state.order_no || "-"}</h6>
                            <h6>broker: {location.state.broker || "-"}</h6>
                            <h6>country: {location.state.country || "-"}</h6>
                        </>
                        :
                        <>
                            {sessionStorage.getItem("order_no") &&
                                <>
                                    <h5 data-lang-str="msn_error404_param" style={{ marginTop: 20 }}> </h5>
                                    <h6>order: {sessionStorage.getItem("order_no") || "-"}</h6>
                                    <h6>broker: {sessionStorage.getItem("broker") || "-"}</h6>
                                    <h6>country: {sessionStorage.getItem("country") || "-"}</h6>
                                </>
                            }
                        </>
                    }
                    <img src={Logo} alt={"Logo Fastcoin"} width="70%" style={{ marginTop: "1em" }} />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Error404
